import Agent from './agent';

const requests = Agent.requests;

const HelpAgent = {
  getHelp: () => requests.get(`/tools/contextual-help`),
};

export default HelpAgent;
